import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import CandidateCard from "../../assets/cards/CandidateCard";

export default function TopCoaches({ coachs }) {
  return (
    <>
      <Box my={8} >
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 5 }}>
          <Typography
            sx={{
              fontFamily: "Inter",
              fontWeight: 600,
              fontSize:{md: "26px", xs: "16px"},
              lineHeight: {md: "32px", xs: "25px"},
            }}
          >
            Top Coaches on PPLACD
          </Typography>
          <Link style={{ textDecoration: 'none', color: '#2544EE' }}>
            <Typography >View More </Typography>
          </Link>
        </Box>
        <Box>
          <Grid container spacing={2} mb={5}>
            {
              coachs && coachs.length > 0
                ?
                coachs.map((item, index) => (
                  <Grid item md={2.4} key={index}>
                    <CandidateCard candidate={item}/>
                  </Grid>
                ))
                :
                ""
            }
          </Grid>
        </Box>
      </Box>
    </>
  )
}
